module.exports = __webpack_public_path__ + "img/上市成功宣传图.baff1246.jpg";